import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { getFontSize } from './utils';

export const CertBodyGrid = ({
  children,
  className,
  gridProps = {},
  typographyProps = {},
  smallWidget,
  historicalView,
  ...props
}) => (
  <Grid
    item
    xs={12}
    style={{ paddingBottom: '1rem' }}
    className={className}
    {...props}
    {...gridProps}
  >
    <Typography
      {...typographyProps}
      style={{ fontSize: getFontSize(smallWidget, historicalView) }}
    >
      {children}
    </Typography>
  </Grid>
);

export default CertBodyGrid;
